export default __webpack_public_path__ + "static/media/ArchiveIcon.02c44078.svg";